import React from 'react';
import {
  Create,
  SimpleForm,
  useCreate,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';


function QuienesSomosCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'fg-quienes-somoss';

  const handleSubmit = async (data: any) => {
    try {
      const payload = {
        descripcion: data.descripcion,
        directorio: data.directorio,
        detalle: data.detalle,
        legal: data.legal,
      };

      create(resourceName, { data: payload }, {
        onSuccess: () => {
          notify('Creado con éxito', { type: 'success' });
          redirect('list', resourceName);
        }
      });
    } catch (e) {
      notify('Error al crear', { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <RichTextInput 
          source="descripcion" 
          label="Descripción"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <RichTextInput
          source="directorio"
          label="Directorio"
          format={blocksToHtml}
          parse={htmlToBlocks}
          fullWidth
        />
        <RichTextInput
          source="detalle"
          label="Detalle"
          format={blocksToHtml}
          parse={htmlToBlocks}
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
}

export default QuienesSomosCreate;
